import {
  AlertTriangle,
  Aperture,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  Check,
  ChevronLeft,
  ChevronRight,
  CircleCheck,
  Copy,
  CreditCard,
  ExternalLink,
  File,
  FileText,
  Globe,
  HelpCircle,
  Image,
  Laptop,
  LayoutDashboard,
  LayoutGrid,
  LayoutList,
  Loader2,
  LucideIcon,
  LucideProps,
  Menu,
  Moon,
  MoreVertical,
  Plus,
  Search,
  Settings,
  Share2,
  Sparkles,
  SunMedium,
  Trash,
  Twitter,
  User,
  X
} from "lucide-react";

export type Icon = LucideIcon;

export const Icons = {
  add: Plus,
  arrowRight: ArrowRight,
  arrowLeft: ArrowLeft,
  arrowUpRight: ArrowUpRight,
  billing: CreditCard,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  check: Check,
  close: X,
  menu: Menu,
  copy: Copy,
  ellipsis: MoreVertical,
  github: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="github"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 496 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
      ></path>
    </svg>
  ),
  google: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="google"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 488 512"
      {...props}
    >
      <path
        d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
        fill="currentColor"
      />
    </svg>
  ),
  help: HelpCircle,
  laptop: Laptop,
  // logo: Puzzle,
  logo: ({ ...props }: LucideProps) => (
    <>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        aria-hidden="true"
        focusable="false"
        data-prefix="fab"
        data-icon="logo"
        role="img"
        {...props}>
        <g id="Page-1" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
          <g id="logo_rocket_man_violet" transform="translate(-0.000000, 0.000000)" fill="#7C3AED" fill-rule="nonzero">
            <g id="Group" transform="translate(256.000000, 256.000000) scale(-1, 1) rotate(-180.000000) translate(-256.000000, -256.000000) translate(0.000000, 0.000000)">
              <path d="M0,256 L0,64 C-4.32866401e-15,28.653776 28.653776,4.32866401e-15 64,0 L256,0 L448,0 C483.346224,-6.49299601e-15 512,28.653776 512,64 L512,256 L512,448 C512,483.346224 483.346224,512 448,512 L256,512 L64,512 C28.653776,512 2.164332e-15,483.346224 0,448 L0,256 Z M261,444.4 C277.1,436.6 286.5,418.9 284,400.9 C279.7,370.8 242.3,356.1 218.4,375.1 C212.6,379.7 207.4,387.2 205,394.6 C201.9,403.7 202.5,416 206.2,424.2 C210.9,434.4 219.7,442.1 231.5,446.2 C235.2,447.6 238.9,448 245.5,447.8 C253.2,447.5 255.4,447 261,444.4 Z M158.6,405.1 C165.6,401.9 167.3,398.5 174.6,373.2 L175.209869,371.088215 C178.81684,358.598404 190.249784,350 203.25,350 L225.2,350 L255.075137,350 C264.315413,350 273.446115,347.999112 281.839589,344.134879 L315.8,328.5 L315.8,328.5 C341.5,316.7 364,306.1 365.8,305 C372.1,301.2 375.9,291.7 374.1,284.5 C373.5,282.2 372.8,279.5 372.4,278.6 C371.9,277.3 372.6,277 377,277 C391.1,277 421,270.6 440,263.5 C455,258 472,250 472,248.6 C472,246.8 456.9,224.4 449.3,215 C421.4,180.3 382.1,153.7 343.9,143.6 C319.7,137.1 266.3,127.9 216,121.4 L169.093887,115.362579 C166.857827,115.07477 164.631024,115.957884 163.2,117.7 L163.2,117.7 L163.2,117.7 C152.1,131 138.4,177.5 140.5,194.5 C140.936212,197.678118 142.960092,200.415653 145.870667,201.764456 L165.8,211 L165.8,211 C179.4,217.2 191.9,223 193.5,223.7 C196.4,225.1 196.6,225 202.1,219.7 C210.5,211.5 215.8,209.4 234.7,206.6 C243.7,205.2 251.3,203.9 251.8,203.6 C252.3,203.3 251.6,199.8 250.2,195.8 C244.1,177.6 250.8,158.3 266.7,148.2 C277.8,141.2 294.2,140 305.1,145.5 C312.5,149.2 318.2,154 321.8,159.7 C324.9,164.6 348.3,218.2 351.4,227.8 C355.1,238.8 353.1,253 346.7,262.2 C340.9,270.5 335.3,274 306.4,287.6 C291.2,294.7 278.4,300.7 277.9,300.8 C277.3,301 277.1,294.4 277.2,284.8 C277.376105,275.23165 284.068744,267.022818 293.40554,264.923156 L298.4,263.8 L298.4,263.8 C309.8,261.3 320.5,258.6 322.1,257.9 C328.9,255.1 334.9,244.1 333.7,236.6 C332.9,231.5 307.6,173.1 304.6,169.3 C298.9,162.2 287.2,159.6 279.2,163.8 C271.7,167.6 267.2,178.3 269.2,187.3 C269.7,189.6 272.8,197.7 276.2,205.3 C279.5,212.9 282.1,219.2 281.9,219.4 C281.7,219.6 268.5,221.6 252.5,224 C219.1,228.9 217.6,229.4 213.4,238.3 C211,243.5 211,243.7 211,276.3 L211,284.5 C211,298.030976 200.030976,309 186.5,309 L186.5,309 L186.5,309 C166.6,309 161.2,309.3 158.2,310.6 C154.3,312.2 149.5,316.2 147.9,319.3 C145.8,323.1 129,383.6 129,387.2 C129,391.8 131.2,397.5 134.3,400.9 C139.7,406.7 150.8,408.7 158.6,405.1 Z M176.5,250.4 C187.9,244.2 191.9,241.5 190.9,240.7 C189.9,239.9 127,211 126.2,211 C124.5,211 109.5,222.1 108.3,224.2 C106.6,227.4 106.7,230.4 108.8,233 C111,235.7 157.5,256.8 161.5,256.9 C163.4,257 168.8,254.6 176.5,250.4 Z M128.2,172.1 C130.3,171.3 130.7,170.2 131.8,162.6 C133.4,151.3 137.2,138.3 141.7,128.8 L143.976852,123.930067 C144.756571,122.262334 144.314298,120.278582 142.9,119.1 L142.9,119.1 L142.9,119.1 C134.8,112.4 121.4,107.6 110.5,107.6 C97.7,107.7 85.9,112.1 72.5,122 C69.325459,124.351512 68.1560995,128.560241 69.6625892,132.212337 L70.4,134 L70.4,134 C72.3,138.4 75.1,144.2 76.6,146.8 C80.7,153.8 91.6,164.1 98.4,167.4 C108,172 122.5,174.3 128.2,172.1 Z M231,106.3 C230.9,104.1 216,79.3 213.8,77.7 C211.9,76.3 205.4,75 187.4,72.4 C158.7,68.4 156.4,68.3 153.3,71.2 C150.1,74.2 150.4,78 154.7,88.6 C156.987171,94.2252041 162.119056,98.1887902 168.139682,98.9800726 L175.9,100 L175.9,100 C185.6,101.2 201.2,103.2 210.5,104.5 C230.9,107.2 231,107.2 231,106.3 Z" id="Shape"></path>
            </g>
          </g>
        </g>
      </svg>
    </>
  ),
  media: Image,
  moon: Moon,
  page: File,
  post: FileText,
  search: Search,
  settings: Settings,
  spinner: Loader2,
  sun: SunMedium,
  trash: Trash,
  twitter: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="twitter"
      role="img"
      {...props}
    >
      <path
        d="M14.258 10.152L23.176 0h-2.113l-7.747 8.813L7.133 0H0l9.352 13.328L0 23.973h2.113l8.176-9.309 6.531 9.309h7.133zm-2.895 3.293l-.949-1.328L2.875 1.56h3.246l6.086 8.523.945 1.328 7.91 11.078h-3.246zm0 0"
        fill="currentColor"
      />
    </svg>
  ),
  jike: ({ ...props }: LucideProps) => (
    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"
      width="48" height="48"
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="jike"
      role="img"
      {...props}>
      <path d="M297.88660622 864.60698169a17.99472925 17.99472925 0 0 1-1.92238933 0.35535076l61.27179093 59.73970488c58.91832035-5.41181725 116.59000035-20.90744035 159.05150293-36.26325333 42.49645511-15.39076551 77.44316302-35.15642311 104.9100288-59.38435413a221.79130027 221.79130027 0 0 0 61.02129778-87.27647574c13.18293049-33.98551325 19.77148302-73.20225565 19.77148302-117.66187804V404.55008711c0-49.51608889 0.18058809-92.43779982 0.53593885-128.73600569 0.35535075-36.3331584 0.57089138-69.10698382 0.57089138-98.42633387l-68.53609245-54.67741297c0 29.24361955-0.18058809 62.01744498-0.53593884 98.31565084s-0.53593885 79.22574222-0.53593884 128.73600569v219.57763982c0 44.45379698-6.58855253 83.6763648-19.77148303 117.62692552a221.8786816 221.8786816 0 0 1-61.02129777 87.27647573c-27.43191325 24.2221056-62.40774827 44.02854115-104.9100288 59.38435413-41.93138915 15.16357405-91.9076864 25.49787307-149.89976463 30.97959538z" fill="currentColor" p-id="3063"></path>
      <path d="M634.59018525 122.59965155c0 29.27857209-0.21554062 62.08735005-0.57089138 98.39138134a13396.43221333 13396.43221333 0 0 0-0.53593885 128.77678364v219.57763982c0 44.45379698-6.58855253 83.6763648-19.80643555 117.62692552a221.85537991 221.85537991 0 0 1-60.98634525 87.27647573c-27.46686578 24.2221056-62.44852622 44.02854115-104.9100288 59.38435413s-93.15432675 25.75419165-152.07264711 31.17183432l-33.05927111-142.02379378c26.85519645-2.98261618 53.48320142-7.79441493 79.68595058-14.38879289a165.97210453 165.97210453 0 0 0 59.62902187-28.46301298c18.05880889-14.06839467 31.70194773-31.77767822 40.96436906-53.1103744 9.19251627-21.3385216 13.78294898-49.51608889 13.78294898-84.5676544 0-28.21251982 0.1048576-57.92217315 0.28544569-89.19886507 0.18058809-31.24173938 0.25049315-63.51457849 0.25049315-96.74861226 0-57.85226809-0.25049315-103.83815111-0.786432-137.99842702-0.57089138-34.16027591-0.9961472-66.04281173-1.35149795-95.68256h179.42882987l0.0524288-0.0233017z" fill="currentColor" p-id="3064"></path>
    </svg>
  ),
  coffee: ({ ...props }: LucideProps) => ( // https://icon-sets.iconify.design/line-md/coffee/
    <svg xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="coffee"
      role="img"
      {...props}>
      <path fill="currentColor" d="m20.216 6.415l-.132-.666c-.119-.598-.388-1.163-1.001-1.379c-.197-.069-.42-.098-.57-.241c-.152-.143-.196-.366-.231-.572c-.065-.378-.125-.756-.192-1.133c-.057-.325-.102-.69-.25-.987c-.195-.4-.597-.634-.996-.788a6 6 0 0 0-.626-.194c-1-.263-2.05-.36-3.077-.416a26 26 0 0 0-3.7.062c-.915.083-1.88.184-2.75.5c-.318.116-.646.256-.888.501c-.297.302-.393.77-.177 1.146c.154.267.415.456.692.58c.36.162.737.284 1.123.366c1.075.238 2.189.331 3.287.37q1.829.074 3.65-.118q.449-.05.896-.119c.352-.054.578-.513.474-.834c-.124-.383-.457-.531-.834-.473c-.466.074-.96.108-1.382.146q-1.767.12-3.536.006a22 22 0 0 1-1.157-.107c-.086-.01-.18-.025-.258-.036q-.364-.055-.724-.13c-.111-.027-.111-.185 0-.212h.005q.416-.09.838-.147h.002c.131-.009.263-.032.394-.048a25 25 0 0 1 3.426-.12q1.011.029 2.017.144l.228.031q.4.06.798.145c.392.085.895.113 1.07.542c.055.137.08.288.111.431l.319 1.484a.237.237 0 0 1-.199.284h-.003l-.112.015a37 37 0 0 1-4.743.295a37 37 0 0 1-4.699-.304c-.14-.017-.293-.042-.417-.06c-.326-.048-.649-.108-.973-.161c-.393-.065-.768-.032-1.123.161c-.29.16-.527.404-.675.701c-.154.316-.199.66-.267 1c-.069.34-.176.707-.135 1.056c.087.753.613 1.365 1.37 1.502a39.7 39.7 0 0 0 11.343.376a.483.483 0 0 1 .535.53l-.071.697l-1.018 9.907c-.041.41-.047.832-.125 1.237c-.122.637-.553 1.028-1.182 1.171q-.868.197-1.756.205c-.656.004-1.31-.025-1.966-.022c-.699.004-1.556-.06-2.095-.58c-.475-.458-.54-1.174-.605-1.793l-.731-7.013l-.322-3.094c-.037-.351-.286-.695-.678-.678c-.336.015-.718.3-.678.679l.228 2.185l.949 9.112c.147 1.344 1.174 2.068 2.446 2.272c.742.12 1.503.144 2.257.156c.966.016 1.942.053 2.892-.122c1.408-.258 2.465-1.198 2.616-2.657l1.024-9.995l.215-2.087a.48.48 0 0 1 .39-.426c.402-.078.787-.212 1.074-.518c.455-.488.546-1.124.385-1.766zm-1.478.772c-.145.137-.363.201-.578.233c-2.416.359-4.866.54-7.308.46c-1.748-.06-3.477-.254-5.207-.498c-.17-.024-.353-.055-.47-.18c-.22-.236-.111-.71-.054-.995c.052-.26.152-.609.463-.646c.484-.057 1.046.148 1.526.22q.865.132 1.737.212c2.48.226 5.002.19 7.472-.14q.675-.09 1.345-.21c.399-.072.84-.206 1.08.206c.166.281.188.657.162.974a.54.54 0 0 1-.169.364zm-6.159 3.9c-.862.37-1.84.788-3.109.788a6 6 0 0 1-1.569-.217l.877 9.004c.065.78.717 1.38 1.5 1.38c0 0 1.243.065 1.658.065c.447 0 1.786-.065 1.786-.065c.783 0 1.434-.6 1.499-1.38l.94-9.95a4 4 0 0 0-1.322-.238c-.826 0-1.491.284-2.26.613"></path>
    </svg>
  ),

  wechat: ({ ...props }: LucideProps) => (
    <svg
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path
        fill="currentColor"
        d="M 19 6 C 9.625 6 2 12.503906 2 20.5 C 2 24.769531 4.058594 28.609375 7.816406 31.390625 L 5.179688 39.304688 L 13.425781 34.199219 C 15.714844 34.917969 18.507813 35.171875 21.203125 34.875 C 23.390625 39.109375 28.332031 42 34 42 C 35.722656 42 37.316406 41.675781 38.796875 41.234375 L 45.644531 45.066406 L 43.734375 38.515625 C 46.3125 36.375 48 33.394531 48 30 C 48 23.789063 42.597656 18.835938 35.75 18.105469 C 34.40625 11.152344 27.367188 6 19 6 Z M 13 14 C 14.101563 14 15 14.898438 15 16 C 15 17.101563 14.101563 18 13 18 C 11.898438 18 11 17.101563 11 16 C 11 14.898438 11.898438 14 13 14 Z M 25 14 C 26.101563 14 27 14.898438 27 16 C 27 17.101563 26.101563 18 25 18 C 23.898438 18 23 17.101563 23 16 C 23 14.898438 23.898438 14 25 14 Z M 34 20 C 40.746094 20 46 24.535156 46 30 C 46 32.957031 44.492188 35.550781 42.003906 37.394531 L 41.445313 37.8125 L 42.355469 40.933594 L 39.105469 39.109375 L 38.683594 39.25 C 37.285156 39.71875 35.6875 40 34 40 C 27.253906 40 22 35.464844 22 30 C 22 24.535156 27.253906 20 34 20 Z M 29.5 26 C 28.699219 26 28 26.699219 28 27.5 C 28 28.300781 28.699219 29 29.5 29 C 30.300781 29 31 28.300781 31 27.5 C 31 26.699219 30.300781 26 29.5 26 Z M 38.5 26 C 37.699219 26 37 26.699219 37 27.5 C 37 28.300781 37.699219 29 38.5 29 C 39.300781 29 40 28.300781 40 27.5 C 40 26.699219 39.300781 26 38.5 26 Z"
      />
    </svg>
  ),
  user: User,
  warning: AlertTriangle,
  externalLink: ExternalLink,
  twitterBird: Twitter,
  layoutList: LayoutList,
  globe: Globe,
  dashboard: LayoutDashboard,
  layoutgrid: LayoutGrid,
  circlecheck: CircleCheck,
  sparkles: Sparkles,
  aperture: Aperture,
  share: Share2,
};
